/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Renegociacao25FinBanner.css';
import RedButton from '@/components/atoms/RedButton';

function Renegociacao25FinBanner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <div className="bg-hero">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 450 && (
                <picture>
                  <source type="image/png" srcSet="assets/renegociacao25/hero-fin/banner-312.png" />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-312.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 450 && width <= 599 && (
                <picture>
                  <source type="image/png" srcSet="assets/renegociacao25/hero-fin/banner-450.png" />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-450.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 599 && width <= 799 && (
                <picture>
                  <source type="image/png" srcSet="assets/renegociacao25/hero-fin/banner-600.png" />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-600.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 799 && width <= 1280 && (
                <picture>
                  <source type="image/png" srcSet="assets/renegociacao25/hero-fin/banner-800.png" />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-800.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1280 && width <= 1359 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/renegociacao25/hero-fin/banner-1280.png"
                  />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-1280.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1359 && width <= 1920 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/renegociacao25/hero-fin/banner-1920.png"
                  />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-1920.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
              {width > 1920 && (
                <picture>
                  <source
                    type="image/png"
                    srcSet="assets/renegociacao25/hero-fin/banner-2650.png"
                  />
                  <img
                    src="assets/renegociacao25/hero-fin/banner-2650.png"
                    alt="Banner focado em renegociação de dívidas de financiamento com o Santander."
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <ContainerHome24>
          <div className="hero-contain">
            <div className="hero-buttons">
              <WhiteButton
                href="https://santanderfinanciamentos.com.br/portalcliente/login"
                target="_blank"
                className="btn-simulate"
              >
                Renegociar
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Renegociacao25FinBanner;
